module.exports = __webpack_public_path__ + "static/media/dialog.5d2ef01a.jpg";